import { HOME, ALL_DEPARTMENTS, ADD_VISITOR, FAILED, START_FORM, CHECK_EMERGENCY_START,
        CHECK_EMERGENCY_SUCCESS, CHECK_EMERGENCY_FAIL } from "../actions/types";

const initialState = {
    success_visitor: false,
    failed_visitor: false,
    loadingEmergency: false,
    emergencyMode: false,
    emergencyText: "",
    emergencyError: null,
};

const dataReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        // -------------------
        // emergency-mode
        // -------------------
        case CHECK_EMERGENCY_START:
            return {
                ...state,
                loadingEmergency: true,
                emergencyError: null
            };

        case CHECK_EMERGENCY_SUCCESS:
            return {
                ...state,
                loadingEmergency: false,
                emergencyMode: action.payload.mode,
                emergencyText: action.payload.text  
            };

        case CHECK_EMERGENCY_FAIL:
            return {
                ...state,
                loadingEmergency: false,
                emergencyError: payload
            };
        case HOME:
            return {
                ...state,
                data: payload,
            }
        case ADD_VISITOR:
            return {
                ...state,
                success_visitor: true,
                failed_visitor: false
            }
        case START_FORM:
            return {
                ...state,
                success_visitor: false,
                failed_visitor: false
            }

        case FAILED:
            return {
                ...state,
                success_visitor: false,
                failed_visitor: true,
                failed_visitor_error: payload.error
            }

        default:
            return state;
}
};

export default dataReducer;
